import type { Theme } from '@material-ui/core/styles';
import { default as MuiAlert } from './MuiAlert';
import { default as MuiAppBar } from './MuiAppBar';
import { default as MuiAutocomplete } from './MuiAutocomplete';
import { default as MuiAvatar } from './MuiAvatar';
import { default as MuiBackdrop } from './MuiBackdrop';
import { default as MuiBadge } from './MuiBadge';
import { default as MuiBreadcrumbs } from './MuiBreadcrumb';
import { default as MuiButton } from './MuiButton';
import { default as MuiCardActions } from './MuiCardActions';
import { default as MuiCardContent } from './MuiCardContent';
import { default as MuiCardHeader } from './MuiCardHeader';
import { default as MuiCheckbox } from './MuiCheckbox';
import { default as MuiChip } from './MuiChip';
import { default as MuiDialogActions } from './MuiDialogActions';
import { default as MuiDialogTitle } from './MuiDialogTitle';
import { default as MuiFormHelperText } from './MuiFormHelperText';
import { default as MuiInputAdornment } from './MuiInputAdornment';
import { default as MuiInputBase } from './MuiInputBase';
import { default as MuiInputLabel } from './MuiInputLabel';
import { default as MuiLinearProgress } from './MuiLinearProgress';
import { default as MuiListItem } from './MuiListItem';
import { default as MuiListItemAvatar } from './MuiListItemAvatar';
import { default as MuiMenuItem } from './MuiMenuItem';
import { default as MuiOutlinedInput } from './MuiOutlinedInput';
import { default as MuiPaper } from './MuiPaper';
import { default as MuiRadio } from './MuiRadio';
import { default as MuiSnackbarContent } from './MuiSnackbarContent';
import { default as MuiStepConnector } from './MuiStepConnector';
import { default as MuiStepIcon } from './MuiStepIcon';
import { default as MuiSvgIcon } from './MuiSvgIcon';
import { default as MuiSwitch } from './MuiSwitch';
import { default as MuiTab } from './MuiTab';
import { default as MuiTableCell } from './MuiTableCell';
import { default as MuiTabs } from './MuiTabs';
import { default as MuiTextField } from './MuiTextField';
import { default as MuiTimelineConnector } from './MuiTimelineConnector';
import { default as MuiTimelineContent } from './MuiTimelineContent';
import { default as MuiTimelineDot } from './MuiTimelineDot';
import { default as MuiTimelineOppositeContent } from './MuiTimelineOppositeContent';
import { default as MuiTooltip } from './MuiTooltip';

export default (theme: Theme): unknown => ({
    MuiAlert: MuiAlert(theme),
    MuiAppBar: MuiAppBar(theme),
    MuiAutocomplete: MuiAutocomplete(theme),
    MuiAvatar: MuiAvatar(),
    MuiBackdrop: MuiBackdrop(theme),
    MuiBadge: MuiBadge(theme),
    MuiBreadcrumbs: MuiBreadcrumbs(theme),
    MuiButton: MuiButton(theme),
    MuiCardActions: MuiCardActions(),
    MuiCardContent: MuiCardContent(),
    MuiCardHeader: MuiCardHeader(),
    MuiCheckbox: MuiCheckbox(theme),
    MuiChip: MuiChip(theme),
    MuiDialogActions: MuiDialogActions(),
    MuiDialogTitle: MuiDialogTitle(),
    MuiFormHelperText: MuiFormHelperText(),
    MuiInputAdornment: MuiInputAdornment(),
    MuiInputBase: MuiInputBase(),
    MuiInputLabel: MuiInputLabel(),
    MuiLinearProgress: MuiLinearProgress(),
    MuiListItem: MuiListItem(theme),
    MuiListItemAvatar: MuiListItemAvatar(),
    MuiMenuItem: MuiMenuItem(theme),
    MuiOutlinedInput: MuiOutlinedInput(theme),
    MuiPaper: MuiPaper(theme),
    MuiRadio: MuiRadio(theme),
    MuiSnackbarContent: MuiSnackbarContent(theme),
    MuiStepConnector: MuiStepConnector(),
    MuiStepIcon: MuiStepIcon(theme),
    MuiSvgIcon: MuiSvgIcon(theme),
    MuiSwitch: MuiSwitch(theme),
    MuiTab: MuiTab(theme),
    MuiTableCell: MuiTableCell(theme),
    MuiTabs: MuiTabs(theme),
    MuiTextField: MuiTextField(),
    MuiTimelineConnector: MuiTimelineConnector(theme),
    MuiTimelineContent: MuiTimelineContent(),
    MuiTimelineDot: MuiTimelineDot(),
    MuiTimelineOppositeContent: MuiTimelineOppositeContent(),
    MuiTooltip: MuiTooltip(theme),
});
